import { render, staticRenderFns } from "./InputKintonSetting.vue?vue&type=template&id=0984da68"
import script from "./InputKintonSetting.vue?vue&type=script&lang=js"
export * from "./InputKintonSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports